import {CommonModule} from '@angular/common';
import {LetDirectiveModule} from 'ng2-app/modules/directives/let/let.directive.module';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {UserAvatarModule} from 'app/user-avatar/user-avatar.module';
import {UserMenuComponent} from './user-menu/user-menu.component';

@NgModule({
  declarations: [
    UserMenuComponent
  ],
  imports: [
    CommonModule,
    LetDirectiveModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    UserAvatarModule,
  ],
  exports: [
    UserMenuComponent,
  ],
})
export class UserMenuModule {}
